import React from 'react';
import { ArrowRight } from 'lucide-react';
export function AnnouncementBanner() {
  return <div className="w-full bg-gate-surface/50 border-b border-gate-border/50 backdrop-blur-sm" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2" data-id="element-15">
        <a href="#" className="flex items-center justify-center gap-2 text-xs sm:text-sm text-gate-text-secondary hover:text-gate-teal transition-colors duration-200 group" data-id="element-16">
          <span className="font-medium text-gate-teal" data-id="element-17">New</span>
          <span data-id="element-18">
            Introducing Bitstream Hot-Swap — deploy new FPGA configs with zero
            downtime.
          </span>
          <span className="flex items-center font-medium group-hover:underline" data-id="element-19">
            Learn more{' '}
            <ArrowRight className="w-3 h-3 ml-1 group-hover:translate-x-0.5 transition-transform" data-id="element-20" />
          </span>
        </a>
      </div>
    </div>;
}